import React from 'react'
import { AboutInnerBanner } from '../../Components/Common/InnerBanner/AboutInnerBanner';
import AboutInnBanContent from '../../Components/Common/InnerBanner/AboutInnBanContent';
import RightHandSide from '../../Components/Common/Services/RightHandSide';
import TopContent from '../../Components/Common/Services/TopContent';
import TopContentTxt from '../../Components/Common/Services/TopContentTxt';
import AllDetails from '../../Components/Common/Services/AllDetails';
import AllDetailsData from '../../Components/Common/Services/AllDetailsData';
import DbListData from '../../Components/Common/Services/DbListData';
import DbList from '../../Components/Common/Services/DbList';
import Transition from '../../Components/Transition';
import { Helmet } from 'react-helmet';


const LaparoscopyHysteroscopy = () => {
  const {image, heading, pageName} = AboutInnBanContent.LaparoscopyHysteroscopy;
  const {banner, head, pOne, pTwo, highligth} = TopContentTxt.LaparoscopyHysteroscopy;
  const {AllDData} = AllDetailsData.LaparoscopyHysteroscopy;
  const {dlHeading, Dldata} = DbListData.LaparoscopyHysteroscopy.Indications;
  const {pHeading, pData} = DbListData.LaparoscopyHysteroscopy.Procedure;


  return (
    <>
    <Helmet>
      <title>Best Laparoscopic Surgery: Indications & Procedures</title>
      <meta name='description' content='Best indications for laparoscopy, including treatment for infertility, endometriosis, and more with minimal recovery time.' />
      <meta name='keywords' content='assisted reproductive technologies, embryo transfer, in vitro fertilization process, icsi, in vitro fertilization, ivf success rates, tsh test, tsh, frozen embryo transfer, icsi procedure ' />
      <link rel="canonical" href="https://www.acmefertility.com/LaparoscopyHysteroscopy" />
      <meta name="robots" content="Index, follow " />
    </Helmet>
    <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

    <div className="blog-details-area pt-100 pb-70">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <TopContent banner={banner} head={head} pOne={pOne} pTwo={pTwo} highligth={highligth} />

            <AllDetails AllDData={AllDData} />

            <DbList dlHeading={dlHeading} Dldata={Dldata} />

            <DbList dlHeading={pHeading} Dldata={pData} />

          </div>
          <div className="col-lg-4">
            <RightHandSide />
        </div>
        </div>
      </div>
    </div>


    </>
  )
}

export default Transition(LaparoscopyHysteroscopy) 
